import GatewayRecordParser, { REPORT_TYPE_EXTENSION } from "./GatewayRecordParser";
import { isRecord, isReplaceChange } from "../types";
import { FIXED_PROTOCOL_TYPE_IDS } from "../../utils/ProtocolTypeUtils";
export default class NoonReportParser extends GatewayRecordParser {
    constructor(app) {
        super(app);
    }
    getProtocolType() {
        return this.localCache.getProtocolType(FIXED_PROTOCOL_TYPE_IDS.NOON_REPORT);
    }
    handlesProtocol() {
        return false;
    }
    handlesRecord(record) {
        let extensions = [];
        if (isRecord(record)) {
            extensions = record.Extensions || [];
        }
        else if (isReplaceChange(record.Changes[0])) {
            extensions = record.Changes[0].ReplacementRecord.Extensions || [];
        }
        else {
            extensions = record.Changes[0].Extensions || [];
        }
        return extensions.some((extension) => extension.Manufacturer === 'ANZ' &&
            extension.Name === REPORT_TYPE_EXTENSION &&
            extension.Value === 'noonReport');
    }
    getEntry(element, record) {
        const entry = super.getEntry(element, record);
        if (!entry && element.name === 'twind') {
            const windForceEntry = record.Entries.find((entry) => entry.Type === 'windF');
            const windDirectionEntry = record.Entries.find((entry) => entry.Type === 'windD');
            if (windForceEntry || windDirectionEntry) {
                const twind = `${windForceEntry?.Value || ''}/${windDirectionEntry?.Value || ''}`;
                return {
                    ...(windForceEntry || windDirectionEntry),
                    Id: this.getEntryId(element, record.Id),
                    Type: element.name,
                    Value: twind,
                };
            }
        }
        if (!entry && element.name === 'swell') {
            const swellHeightEntry = record.Entries.find((entry) => entry.Type === 'swellH');
            const swellDirectionEntry = record.Entries.find((entry) => entry.Type === 'swellD');
            if (swellHeightEntry || swellDirectionEntry) {
                const swell = `${swellDirectionEntry?.Value || ''}/${swellHeightEntry?.Value || ''}`;
                return {
                    ...(swellHeightEntry || swellDirectionEntry),
                    Id: this.getEntryId(element, record.Id),
                    Type: element.name,
                    Value: swell,
                };
            }
        }
        return entry;
    }
}
//# sourceMappingURL=NoonReportParser.js.map